import AssessmentResultsDisplay from './AssessmentResultsDisplay';

export default AssessmentResultsDisplay;
